/**
 * Colours for added and removed text in a note diff.
 *
 * Not colour alone: an addition is underlined and a removal struck through, so the diff survives
 * both colour-blindness and a greyscale print of the chart. The background tint is the redundant
 * cue, not the only one.
 */
export const ADDED_CLASS =
  'bg-emerald-500/15 text-emerald-900 underline decoration-emerald-600/50 dark:text-emerald-200';
export const REMOVED_CLASS = 'bg-rose-500/15 text-rose-900 line-through decoration-rose-600/50 dark:text-rose-200';

/** Mirrors one part of `NoteDiffSegment` from `@liza/services`; see `NoteDiffPart` for why. */
export type NoteDiffPartView = { kind: 'unchanged' | 'added' | 'removed'; value: string };
